import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { PageHelper } from "../../helpers";
import { LoaderComponent } from "./layout";

class UrlInternalFormComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            show: false,
            loading: true,
            language: props.language ? props.language : 'nl',
            links: [],
            collapsed: [],
            showTopArrow: false,
            showBottomArrow: false,
        }

        this.modalBodyRef = null;
        this.setModalBodyRef = (el) => { this.modalBodyRef = el; };

        this.toggleModal = this.toggleModal.bind(this);
        this.selectUrl = this.selectUrl.bind(this);
    }

    componentDidMount() {
        Promise.all([
            PageHelper.generateInternalLinkList({ language: this.state.language })
        ])
            .then(result => {
                let linkList = [];
                linkList = this.assembleLinkList(linkList, result[0]);

                this.setState({ links: linkList, loading: false });
            });
    }

    componentDidUpdate() {
        this.showHideCaret();
        this.checkScrollIndicators();
    }

    checkScrollIndicators = () => {
        const el = this.modalBodyRef;
        if (!el) return;
        const { scrollTop, scrollHeight, clientHeight } = el;
        const hasOverflow = scrollHeight > clientHeight;
        const showTopArrow = hasOverflow && scrollTop > 0;
        const showBottomArrow = hasOverflow && scrollTop + clientHeight < scrollHeight - 1;
        if (showTopArrow !== this.state.showTopArrow || showBottomArrow !== this.state.showBottomArrow) {
            this.setState({ showTopArrow, showBottomArrow });
        }
    }

    showHideCaret = () => {
        let collapseElements = document.querySelectorAll('.fa-angle-right');

        collapseElements.forEach(el => {
            let parent = el.closest('.internal-pages-select-item');
            let children = document.querySelectorAll('.internal-pages-select-item[data-parent="' + parent.dataset.key + '"]');

            if (children.length <= 0) {
                el.classList.add('visually-hidden');
            }
        });
    }

    assembleLinkListCategories = (list, page, categories, parent, depth = 1) => {
        Object.keys(categories).forEach(id => {
            let category = categories[id];
            let content = category.category.contents.find(content => content.language === this.state.language);

            list.push({
                title: content ? content.title : null,
                url: '/' + (content ? content.language : 'nl') + '/permalink/category/' + category.category.id + '/' + page.id,
                depth: depth,
                key: id,
                parent: parent
            });

            if (Object.keys(category.children).length > 0) {
                this.assembleLinkListCategories(list, page, category.children, id, depth + 1);
            }
        });
    }

    assembleLinkList = (list, items, parent, depth = 0, ancestors = []) => {
        items.forEach((item, index) => {
            // unieke key op basis van positie in de boom, want dezelfde pagina kan meerdere keren voorkomen
            let key = (parent ? parent + '/' : '') + index + '-' + item.id;

            list.push({
                ...item, ...{
                    key: key,
                    parent: parent,
                    ancestors: ancestors,
                    depth: depth
                }
            });

            if (item.children?.length > 0) {
                this.assembleLinkList(list, item.children, key, depth + 1, [...ancestors, key]);
            }
        });
        return list;
    }

    toggleModal = () => this.setState({ show: !this.state.show, collapsed: [] })

    selectUrl = (event) => {
        if (this.props.handleUrlSelect) {
            this.props.handleUrlSelect(event);
        } else {
            let item = event.target.closest('.internal-pages-select-item')

            let url = item.dataset.url;
            url = url.replace("https://", '')

            let media = this.props.parent.form.state.values;
            media.url = url;

            this.props.parent.form.setState({ values: media });
        }

        this.toggleModal();
    }

    toggleCollapse = (e) => {
        e.preventDefault();
        e.stopPropagation();

        let clickedEl = e.target.closest('.internal-pages-select-item');
        if (!clickedEl) return;

        let key = clickedEl.dataset.key;
        let collapsed;

        if (this.state.collapsed.indexOf(key) < 0) {
            // openklappen
            collapsed = [...this.state.collapsed, key];
        } else {
            // dichtklappen, ook alle onderliggende items terug dichtklappen
            collapsed = this.state.collapsed.filter(k => k !== key && !k.startsWith(key + '/'));
        }

        this.setState({ collapsed });
    }

    render() {
        return (
            <>
                <FormattedMessage id="CMS.Page.Content.Form.internal.url.link">
                    {(value) =>
                        <Link to="#" className={"internalLinkSelector"} onClick={this.toggleModal}>
                            {value}
                        </Link>
                    }
                </FormattedMessage>

                <Modal show={this.state.show} onHide={this.toggleModal} animation={false} size="md" className="internal-pages-select-modal" centered>
                    <Modal.Header closeButton>
                        <FormattedMessage id="CMS.Page.Content.Form.internal.url.title">
                            {(value) => <Modal.Title>{value}</Modal.Title>}
                        </FormattedMessage>
                    </Modal.Header>
                    <Modal.Body ref={this.setModalBodyRef} onScroll={this.checkScrollIndicators}>
                        {this.state.showTopArrow && (
                            <div className="scroll-indicator scroll-indicator-top">
                                <FontAwesomeIcon icon={['fal', 'chevron-up']} />
                            </div>
                        )}
                        {this.state.loading && <LoaderComponent />}
                        <div className="internal-pages-select">
                            {this.state.links.map(link => {
                                let classes = ["internal-pages-select-item sub-" + link.depth];
                                if (link.ancestors.some(ancestor => this.state.collapsed.indexOf(ancestor) < 0)) {
                                    classes.push('visually-hidden');
                                }
                                if (link.disabled) classes.push('disabled');

                                return <div key={link.key} onClick={!link.disabled ? this.selectUrl : null} className={classes.join(' ')}
                                    data-key={link.key} data-parent={link.parent} data-url={link.url}
                                >

                                    <div className="internal-pages-select-item-start">
                                        {link.children.length > 0 && (
                                            <FontAwesomeIcon icon={['fal', this.state.collapsed.indexOf(link.key) > -1 ? 'angle-down' : 'angle-right']} onClick={!link.disabled ? this.toggleCollapse : null} />
                                        )}
                                        <p>{link.title}</p>
                                    </div>

                                    <div className="internal-pages-select-item-end">
                                        <FontAwesomeIcon icon={['fal', 'arrow-right']} className="arrow" />
                                    </div>
                                </div>;
                            })}
                        </div>
                        {this.state.showBottomArrow && (
                            <div className="scroll-indicator scroll-indicator-bottom">
                                <FontAwesomeIcon icon={['fal', 'chevron-down']} />
                            </div>
                        )}
                    </Modal.Body>
                </Modal>
            </>
        );
    }
}

UrlInternalFormComponent.propTypes = {
    values: PropTypes.array.isRequired,
    parent: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.array.isRequired
};

export default UrlInternalFormComponent;